import React from 'react'
import PropTypes from 'prop-types';
import { Link, useStaticQuery, graphql } from "gatsby";
import Img from 'gatsby-image';

import { formatPrice } from '../../helpers/currency';
import { fromProductSlugToUrl } from '../../helpers/products';
import { findSalePrice } from '../../helpers/findSalePrice';

import ProductColour from '../../components/ProductColour/ProductColour'

export default function ProductCard( props ) {

	const data = useStaticQuery(graphql`
		query getSales {
			strapi {
				sales( where:{ allProducts: true } ) {
					discount
					amount
				}
			}
		}
	`)

	const { sales } = data.strapi
	const { product } = props

	findSalePrice( product, sales )

	return (
		<div className="product-card">
			<div className="product-card__container" key={ product.id }>
				<Link
					to={fromProductSlugToUrl( product.slug )}
					className="product-card__item-link">
					<div className="product-card__item-image-container">
						<Img className="product-card__item-image" fluid={{ ...product.images[0].imageFile.childImageSharp.fluid, aspectRatio: 1/1 }} />
					</div>
					<div className="product-card__item-meta-wrapper">
						<h3 className="product-card__item-name">{ product.name }</h3>
						<div className="product-card__item-price-container">
							{ product.salePrice && 
								<div className="product-card__item-price product-card__item-price--sale"> { formatPrice( product.salePrice ) } </div>
							}
							<span className={ `product-card__item-price ${ product.salePrice ? "disabled" : ''}` }>{ formatPrice( product.price ) }</span>
						</div>
					</div>
				</Link>

				{ product.colour_option &&
					<div className="product-card__colour-container">
						<ProductColour product={ product } disableText={ true } />
					</div>
				}
			</div>
		</div>
	)
}

ProductCard.propTypes = {
	product: PropTypes.object,
	showCartButton: PropTypes.bool
};
